export var ACTION;
(function (ACTION) {
    ACTION["AADHAR_INIT"] = "AADHAR_INIT";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["FAILED_VERIFICATION"] = "FAILED_VERIFICATION";
    ACTION["SUCCESS_VERIFICATION"] = "SUCCESS_VERIFICATION";
    ACTION["DOCUMENT_UPLOAD"] = "DOCUMENT_UPLOAD";
    ACTION["DIGIO_ANDROID_CALLBACK"] = "DIGIO_ANDROID_CALLBACK";
    ACTION["BAJAJ_DIGIO_INIT"] = "BAJAJ_DIGIO_INIT";
    ACTION["DO_KYC_LATER"] = "DO_KYC_LATER";
})(ACTION || (ACTION = {}));
